module.exports = __webpack_public_path__ + "static/media/umrah-package-4.c52eca04.jpg";